module.exports = __webpack_public_path__ + "media/newstyle/images/icon-image-gallery-0a3857d2e0eb417a29dba75b943085a8.svg";